import React from 'react'
import { format } from 'date-fns-tz'
import { Text } from 'marketing-site/src/library/elements/Text'
import { CTALink } from 'marketing-site/src/library/elements/CTALink'
import { IProps } from './index'
import { CTATheme } from 'marketing-site/src/library/utils'
import { useBrand, BrandOptions } from 'marketing-site/src/library/providers/brandProvider'
import { ScheduledWebinars as ScheduledWebinarsDefault } from './component'
import styles from './styles-legacy.scss'

export const ScheduledWebinars = (props: IProps) => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <ScheduledWebinarsDefault {...props} />
  }
  return <ScheduledWebinarsLegacy {...props} />
}

function ScheduledWebinarsLegacy({ heading, webinars }: IProps) {
  const redirect = (url: string) => () => (window.location.href = url)

  return (
    <section className="scheduled-webinars">
      <h2>
        <Text size="xxl+">{heading}</Text>
      </h2>
      <div className="scheduled-webinars__wrapper">
        {webinars
          .sort((a, b) => {
            return a.zoom && b.zoom ? a.zoom?.startTimestamp - b.zoom?.startTimestamp : 1
          })
          .map((webinar, key) => (
            <div
              onClick={redirect(webinar.url)}
              onKeyPress={redirect(webinar.url)}
              role="button"
              className="scheduled-webinar"
              key={key}
              tabIndex={0}
            >
              <div>
                <h3 className="scheduled-webinar__title">
                  <Text size="lg+">{webinar.title}</Text>
                </h3>
                {webinar.zoom && (
                  <p className="scheduled-webinar__date">
                    <Text size="body">
                      {format(webinar.zoom.startTimestamp, 'LLLL dd, h:mm bbb z')}
                    </Text>
                  </p>
                )}
              </div>
              <CTALink
                url={webinar.url}
                text="Learn more"
                small={true}
                arrow={true}
                bgColor={CTATheme.LinkOnlyBlack}
              />
            </div>
          ))}
      </div>
      <style jsx>{styles}</style>
    </section>
  )
}
